export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Meat & Poultry",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/fresh-yields.jpg",
      title: "Fresh Yields Sdn Bhd",
      subtitle: "Taste our selection of grass-fed beef from Australia",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/merchant/penang-delivery-fresh-yields-sdn-bhd"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/home-chef.jpg",
      title: "Home Chef",
      subtitle: "Fresh seafood, Wagyu, chicken breast and others with seasoning combo",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-home-chef"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/ohmypork.jpg",
      title: "ohmypork",
      subtitle: "Providing a variety of pork meat",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/merchant/penang-delivery-ohmypork"
    }
  ],
}
